export const buildOwnershipExportCsv = (documents = []) => {
  const headers = ['Document Name', 'Add To Ownership', 'Song Count', 'Ownership For'];
  const rows = documents.map((doc) => [
    doc.name || doc.document_name || '—',
    doc.addToOwnership || (doc.is_ownership ? 'Yes' : 'No') || '—',
    doc.songCount || doc.song_count || 0,
    doc.ownershipFor || doc.tags || doc.document_tag || '—'
  ]);

  return [
    headers.join(','),
    ...rows.map((row) => row.map((val) => `"${String(val).replace(/"/g, '""')}"`).join(','))
  ].join('\n');
};

export const downloadCsv = (csvContent, filename) => {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const downloadUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('href', downloadUrl);
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(downloadUrl);
};
